// AccessDenied — rendered when a signed-in user is NOT in the admin allowlist.
// Plan ref: 05-00 §Task 2 step 19.

import { supabase } from '@/lib/supabase';

export function AccessDenied(): JSX.Element {
  return (
    <main className="grid min-h-screen place-items-center bg-surface-0 p-6">
      <div className="max-w-md space-y-3 text-center">
        <h1 className="text-lg font-semibold text-fg-default">Access denied</h1>
        <p className="text-sm text-fg-muted">
          This Studio session is not authorised. Contact the admin to be added to the allowlist.
        </p>
        <button
          type="button"
          onClick={() => {
            void supabase.auth.signOut();
          }}
          className="rounded bg-accent-9 px-4 py-2 text-sm font-medium text-fg-on-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface-0"
        >
          Sign out
        </button>
      </div>
    </main>
  );
}
